
import { jitsiLocalStorage } from '@jitsi/js-utils';

import UIEvents from '../../../../service/UI/UIEvents';
import { createToolbarEvent, sendAnalytics } from '../../analytics';
import { OPEN_LOBBY } from '../../lobby/actionTypes';
import { toggleNoiseSuppression } from '../../noise-suppression/actions';
import { setPrejoinPageVisibility, setSkipPrejoinOnReload } from '../../prejoin';
import { getActiveDOMDocument } from '../config/functions.any';
import { MHConferenceErrors } from '../lib-meet-hour';
import { USER_WAITING_REGISTER } from '../premeeting/components/web/constants';
import { MiddlewareRegistry } from '../redux';
import { stopSound, unregisterSound } from '../sounds';
import { TOGGLE_SCREENSHARING } from '../tracks/actionTypes';

import { CONFERENCE_FAILED, CONFERENCE_JOINED, MH_CONFERENCE_JOINED } from './actionTypes';
import { inIframe } from './functions';
import './middleware.any';

declare var APP: Object;


MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    const { enableForcedReload } = getState()['features/base/config'];

    switch (action.type) {
    case CONFERENCE_JOINED: {
        const result = next(action);
        const noiseSuppression = jitsiLocalStorage.getItem('react/features/noise-suppression/enabled') === 'true';

        if (enableForcedReload) {
            dispatch(setPrejoinPageVisibility(false));
            dispatch(setSkipPrejoinOnReload(false));
        }
        dispatch({
            type: OPEN_LOBBY,
            lobbyscreen: {
                _isLobbyScreenVisible: false,
                _isPrejoin: false
            }
        });
        dispatch(stopSound(USER_WAITING_REGISTER));
        dispatch(unregisterSound(USER_WAITING_REGISTER));

        if (noiseSuppression) {
            sendAnalytics(createToolbarEvent('noise.suppression.toggled'));
            dispatch(toggleNoiseSuppression());
        }
        const state = APP.store.getState();
        const activeWindow = getActiveDOMDocument(state);

        const videoSpace = activeWindow.getElementById('videospace');

        if (videoSpace) {
            videoSpace.style.display = 'block';

        }
        const styleB = activeWindow.querySelector('.new-toolbox');

        if (styleB) {
            styleB.style.display = 'block';
        }

        dispatch({
            type: MH_CONFERENCE_JOINED,
            mhconferenceJoined: true
        });

        const query = activeWindow.querySelector('.watermark');

        if (query && inIframe()) {
            query.style.zIndex = 1;
        }

        return result;
    }
    case CONFERENCE_FAILED: {
        enableForcedReload
            && action.error?.name === MHConferenceErrors.CONFERENCE_RESTARTED
            && dispatch(setSkipPrejoinOnReload(true));

        break;
    }
    case TOGGLE_SCREENSHARING: {
        if (typeof APP === 'object') {
            APP.UI.emitEvent(UIEvents.TOGGLE_SCREENSHARING);
        }

        break;
    }
    }

    return next(action);
});

